import {
    ConfirmationPageReferralExperimentVariant,
    ExpressOnlyCheckoutExperimentVariant,
    ExpressPaymentMethods,
    FollowCardPlacementExperimentVariant,
    PostCheckoutMandatoryCustomQuestionsVariant,
    PostCheckoutMandatoryQuestionsInAppVariant,
} from './types';

const ORDER_FORM_PAGE_EXPERIMENTS_LAYER = 'checkout_checkout_page_experiments';
const ORDER_CONFIRMATION_PAGE_EXPERIMENTS_LAYER =
    'checkout_order_confirmation_page_experiments';
const TICKET_SELECTION_PAGE_EXPERIMENTS_LAYER =
    'checkout_ticket_selection_page_experiments';

export const GOOGLE_PAY_ON_TICKET_SELECTION_PAGE_EXPERIMENT = {
    defaultValue: ExpressPaymentMethods.paypal,
    layer: TICKET_SELECTION_PAGE_EXPERIMENTS_LAYER,
    param: 'express_gpay_or_paypal',
};

export const POST_CHECKOUT_MANDATORY_CUSTOM_QUESTIONS = {
    defaultValue:
        PostCheckoutMandatoryCustomQuestionsVariant.optionalAndCannedQuestions,
    layer: ORDER_FORM_PAGE_EXPERIMENTS_LAYER,
    param: 'post_checkout_page_questions',
};

export const POST_CHECKOUT_MANDATORY_QUESTIONS_IN_APP = {
    defaultValue:
        PostCheckoutMandatoryQuestionsInAppVariant.optionalQuestionsInApp,
    layer: ORDER_FORM_PAGE_EXPERIMENTS_LAYER,
    param: 'post_checkout_page_questions_in_app',
};

export const FOLLOW_CARD_PLACEMENT_EXPERIMENT = {
    defaultValue: FollowCardPlacementExperimentVariant.topFollowCard,
    layer: ORDER_CONFIRMATION_PAGE_EXPERIMENTS_LAYER,
    param: 'follow_card_placement',
};

export const ORDER_CONFIRMATION_PAGE_REFERRAL_EXPERIMENT = {
    defaultValue: ConfirmationPageReferralExperimentVariant.control,
    experiment: 'referrals_in_order_confirmation',
    param: 'variant_to_show',
};

export const EXPRESS_CHECKOUT_ONLY_CHECKOUT_EXPERIMENT = {
    defaultValue: ExpressOnlyCheckoutExperimentVariant.notEnabled,
    layer: TICKET_SELECTION_PAGE_EXPERIMENTS_LAYER,
    param: 'express_only_checkout',
};
